import React from 'react';
import {Page, PagePanel} from "../../../components/helpers/PagePanel";
import {ExternalLink, MailTo} from "../../../components/helpers/EasyLinks";
import {Link} from "react-router-dom";
import "./CFP.css"

export const CFPPage = () => (
    <Page>
        <PagePanel title="GR8Conf CFP">
            <p className="lead"> The GR8Conf Call For Papers is open! Submit your talks <ExternalLink
                link="https://cfp.gr8conf.org">here</ExternalLink>.
            </p>
            <p className="text-center">
                <ExternalLink className="btn btn-lg btn-primary" link="http://cfp.gr8conf.org" target="_blank">
                    Submit your talks!
                </ExternalLink></p>
            <h2>The GR8Conf Audience</h2>
            <p> Historically, the audience has consisted of a mix of mostly Java and Groovy software developers. While
                hard to quantify exactly, there has been a sizable contingent of GR8 technology newbies, and a roughly
                equal sized contingent of experienced, practicing developers. Roughly one third have used the
                technologies, though as their primary technology. It would be GR8 if you could keep this in mind when
                developing your proposals. For the GR8Conf EU 2017, we would also like to encourage DevOps talks. While
                these talks do not have to be related to Groovy, it would be great, if the talks proposed are with a
                Groovy angle.
            </p>
            <h2>General topic guidelines</h2>
            <p>
                The conference covers technologies in the Groovy ecosystem, such as Grails, Griffon, Spock, GPars,
                Gradle and many others. We prefer talks that has a technical foundation, and we love code examples - and
                so does the attendees!
            </p>
            <p>
                While GR8Conf is not a DevOps conference, we still accept talks related to DevOps as it is the every day
                life of a modern developer. It could be talks on continuous integration tools, build tools, continuous
                deployment tools, deployment platforms and more. While you can submit all kinds of talks in the DevOps
                space we would prefer that they have a Groovy twist.
            </p>
            <h2>Practical information</h2>
            <p>
                The standard time slot for a presentation at GR8Conf ranges from 15 minutes to 50 minutes, with a main
                focus on 50 minutes talks. University sessions are three to four hours, including time for one 15 minute
                snack break.
            </p>
            <p>
                We encourage technical talks, supporting material, and references to provide conference attendees with
                additional details.
            </p>
            <p>
                Presentations that are little more than product or personal promotion (commercialism), will be rejected.
                If you want to give a commercial/promotional presentation, contact us about sponsorship. If you are
                uncertain whether or not your presentation will be deemed as commercial, please contact us before
                submission.
            </p>
            <p>
                We will not reject any proposal a priori as long as it complies with these general guidelines.
                Preference will be given to those that are aligned with one or more of the topics listed under
                Conference topics or Workshop topics. Preference will also be given to those that submit more than one
                presentation.
            </p>
            <h2>Conference topics</h2>
            <p>
                Think of the topics below as inspiration for talks. The list is by no meanscomplete. Your presentation
                could be on one or more of these areas:
            </p>
            <ul>
                <li>Build and deployment</li>
                <li>Microservices - show us how you did it!</li>
                <li>SPA - get it into production</li>
                <li>Mobile</li>
                <li>Big data / NoSQL</li>
                <li>Cloud</li>
                <li>
                    Plugins - creating plugins, advanced plugin creation, using specific plugins, useful plugins that
                    peer developers should know about.
                </li>
                <li>Testing</li>
                <li>Functional Programming</li>
                <li>
                    Real world experiences - these could be 15, 30 or 60 minute presentations on anything significant
                    you have developed, including challenges and unexpected benefits.
                </li>
                <li>
                    Enterprise - Challenges and successes of integrating GR8 technologies with existing legacy, selling
                    management on GR8 technologies.
                </li>
            </ul>
            <p>
                When you submit your talk, please tag your presentation with one or more of these tags, and add your
                own, if one is missing:
            </p>
            <div className="three-columns">
            <ul>
                <li>Groovy</li>
                <li>Grails</li>
                <li>Micronaut</li>
                <li>Ratpack</li>
                <li>Spock Framework</li>
                <li>GEB</li>
                <li>Gradle</li>
                <li>Building Tools</li>
                <li>Continuous Integration</li>
                <li>Continuous Deployment</li>
                <li>Deployment Platforms</li>
                <li>Deployment Tools</li>
                <li>Android w/Groovy</li>
                <li>Griffon</li>
                <li>Spring Boot</li>
                <li>Testing</li>
                <li>Parallelization</li>
                <li>Meta programming</li>
                <li>Frontend</li>
                <li>Backend</li>
                <li>HTML5 / CSS3 / Javascript</li>
                <li>AngularJS</li>
                <li>ReactJS</li>
                <li>VueJS</li>
                <li>Vanilla Javascript</li>
                <li>Cloud</li>
                <li>NoSQL</li>
                <li>Mobile</li>
                <li>In production / Use cases</li>
                <li>Security</li>
                <li>Integration</li>
            </ul>
            </div>
            <h3>Workshop topics</h3>
            <p>
                We will have a number of workshops in parallel to the conference. If you have a subject that would fit
                into this format, please let us know!
            </p>
            <h2>Admission and travel</h2>
            <p>
                It is important for GR8Conf to keep the cost of travel and lodging to a minimum. Therefore, we hope your
                company/employer can cover your expenses. We will consider this as a partnership for the conference, and
                will place your company in the partnership program accordingly. For more information, please
                contact <MailTo email="sponsors@gr8conf.org"/>
            </p> <h4>All speakers will receive:</h4>
            <ul>
                <li>Complimentary VIP pass to GR8Conf, including an invitation to speakers dinner.</li>
                <li>Up to three nights of stay at the hotel picked by the organizers.</li>
                <li>
                    If your company cannot cover your expenses, you can expect a €500 stipend for European travel
                    expenses to be arranged after proposal acceptance. To keep budget manageable we ask that speakers be
                    as flexible as possible with flights and airlines. Travel expenses from outside Europe will be
                    determined on a case by case basis.
                </li>
            </ul>
            <h2>Presentation information</h2>
            <p> Presentations do not need to be provided or approved prior to speaking.</p>
            <p>
                We ask, that a copy of the slidedeck is made available to the crew after the presentation, so that we
                can publish it online (Slideshare or alike)
            </p>
            <p>
                All presentations are subject to being recorded and can made available to the public without further
                remuneration to the presenter. Do not include any proprietary material that cannot meet this
                requirement.
            </p>
            {/*<h2>GR8Conf interview on the Groovy Podcast</h2>
            <p>
                GR8Conf is working together with the Groovy Podcast, who will do a series of interviews with our
                speakers (that means you). Therefore we will share your name and email address with the Grails Podcast
                crew, in order for them to do contact you, for an interview prior to the conference. This is a great
                opportunity for you to promote your talk, your favorite technology and of course GR8Conf.
            </p>*/}
            <h2>Notes on submitting a presentation</h2>
            <p>
                When submitting a presentation for consideration, it is important that you provide all requested
                information. The contact information you provide with your submission will be used for all future
                correspondence and should reflect a location where you can be reached throughout the conference planning
                period. Please notify us if your contact information changes. We will notify applicants of acceptance,
                using the information provided, according to the schedule above. When submitting a presentation, you
                will accept the <Link to="/code-of-conduct">Conference Code of Conduct</Link>.
            </p>
            <h2>Questions?</h2>
            <p>If you have any questions, contact <MailTo email="info@gr8conf.org"/>.</p>

        </PagePanel>
    </Page>
);





// WEBPACK FOOTER //
// ./src/pages/information/cfp/CFP.js